export enum ReferralType {
  SIGNUP = "signup",
  ORDER = "order"
}
